import api from '../api';

import type { QueryFunction } from '@tanstack/react-query';
import type { OrderType } from 'domains/order';

type APIResponse = {
  data: OrderType[];
  pagination: {
    currentPage: number;
    pageSize: number;
    totalSize: number;
    totalPages: number;
    hasMorePages: boolean;
  };
  success: boolean;
};

export const getOrders: QueryFunction<Omit<APIResponse, 'success'>, ['orders']> = async ({
  pageParam = 1,
  meta = {
    limit: 12,
  },
}) => {
  const { data, pagination } = (await api
    .get(`/reseller/v2/list/orders?page=${pageParam}&limit=50`)
    .then((resp) => resp)) as APIResponse;

  return {
    data,
    pagination,
  };
};
